import { MovieStreamFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { transformSubtitles } from '../../movie-player/transformers/transform-subtitles';
import { getNotNullableItems } from '../../../lib/get-not-nullable-items';

export const getChannelSubtitles = (stream: MovieStreamFragment | null) => {
    const subtitles = getNotNullableItems(stream?.streamMeta?.subtitleMetas);

    return transformSubtitles(subtitles);
};
